// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/TaxSummary/TaxSummary.css */

.tax-summary-container {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-top: 16px;
}

.tax-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.tax-header h4 {
  margin: 0;
  color: #8E44AD;
  font-size: 16px;
}

.tax-loading {
  text-align: center;
  padding: 24px;
  color: #7F8C8D;
}

.no-incomes-warning {
  text-align: center;
  padding: 24px;
  color: #7F8C8D;
  background-color: #FEF9E7;
  border-radius: 4px;
  border: 1px solid #F39C12;
  line-height: 1.6;
}

/* Sections */
.tax-section {
  background-color: white;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tax-section h5 {
  margin: 0 0 12px 0;
  color: #34495E;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #ECF0F1;
  padding-bottom: 8px;
}

/* Table */
.tax-table {
  width: 100%;
  border-collapse: collapse;
}

.tax-table td {
  padding: 8px 4px;
  border-bottom: 1px solid #ECF0F1;
  font-size: 13px;
}

.tax-table td:first-child {
  color: #7F8C8D;
}

.tax-table td.amount,
.tax-table td.value {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  color: #2C3E50;
}

.tax-table td.negative {
  color: #27AE60;
}

.tax-table tr.highlight td {
  background-color: #EBF5FB;
  font-weight: 500;
}

.tax-table tr.warning td {
  background-color: #FEF9E7;
}

/* Capped badge */
.capped-badge {
  display: inline-block;
  background-color: #E74C3C;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 8px;
  font-weight: 600;
}

.capped-info {
  font-size: 11px;
  color: #7F8C8D;
  display: block;
}

/* Result section */
.result-section {
  background-color: #F4ECF7;
  border: 2px solid #8E44AD;
}

.result-section h5 {
  color: #8E44AD;
  border-bottom-color: #D2B4DE;
}

.tax-table tr.total-row td {
  padding: 12px 4px;
  border-bottom: none;
}

.tax-table .tax-amount {
  font-size: 20px;
  color: #8E44AD;
}

.tax-table .tmi {
  font-size: 16px;
  color: #E74C3C;
  font-weight: 600;
}

/* Barème info */
.bareme-info {
  background-color: #EBEDEF;
}

.bareme-info h5 {
  color: #7F8C8D;
}

.bareme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px;
}

.bareme-item {
  font-size: 12px;
  color: #7F8C8D;
  padding: 6px 10px;
  background-color: white;
  border-radius: 4px;
  border-left: 3px solid #BDC3C7;
}

.bareme-item:nth-child(2) {
  border-left-color: #3498DB;
}

.bareme-item:nth-child(3) {
  border-left-color: #F39C12;
}

.bareme-item:nth-child(4) {
  border-left-color: #E67E22;
}

.bareme-item:nth-child(5) {
  border-left-color: #E74C3C;
}
`, "",{"version":3,"sources":["webpack://./src/components/TaxSummary/TaxSummary.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* src/components/TaxSummary/TaxSummary.css */\n\n.tax-summary-container {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.tax-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.tax-header h4 {\n  margin: 0;\n  color: #8E44AD;\n  font-size: 16px;\n}\n\n.tax-loading {\n  text-align: center;\n  padding: 24px;\n  color: #7F8C8D;\n}\n\n.no-incomes-warning {\n  text-align: center;\n  padding: 24px;\n  color: #7F8C8D;\n  background-color: #FEF9E7;\n  border-radius: 4px;\n  border: 1px solid #F39C12;\n  line-height: 1.6;\n}\n\n/* Sections */\n.tax-section {\n  background-color: white;\n  border-radius: 4px;\n  padding: 16px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.tax-section h5 {\n  margin: 0 0 12px 0;\n  color: #34495E;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #ECF0F1;\n  padding-bottom: 8px;\n}\n\n/* Table */\n.tax-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.tax-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid #ECF0F1;\n  font-size: 13px;\n}\n\n.tax-table td:first-child {\n  color: #7F8C8D;\n}\n\n.tax-table td.amount,\n.tax-table td.value {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: #2C3E50;\n}\n\n.tax-table td.negative {\n  color: #27AE60;\n}\n\n.tax-table tr.highlight td {\n  background-color: #EBF5FB;\n  font-weight: 500;\n}\n\n.tax-table tr.warning td {\n  background-color: #FEF9E7;\n}\n\n/* Capped badge */\n.capped-badge {\n  display: inline-block;\n  background-color: #E74C3C;\n  color: white;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  margin-left: 8px;\n  font-weight: 600;\n}\n\n.capped-info {\n  font-size: 11px;\n  color: #7F8C8D;\n  display: block;\n}\n\n/* Result section */\n.result-section {\n  background-color: #F4ECF7;\n  border: 2px solid #8E44AD;\n}\n\n.result-section h5 {\n  color: #8E44AD;\n  border-bottom-color: #D2B4DE;\n}\n\n.tax-table tr.total-row td {\n  padding: 12px 4px;\n  border-bottom: none;\n}\n\n.tax-table .tax-amount {\n  font-size: 20px;\n  color: #8E44AD;\n}\n\n.tax-table .tmi {\n  font-size: 16px;\n  color: #E74C3C;\n  font-weight: 600;\n}\n\n/* Barème info */\n.bareme-info {\n  background-color: #EBEDEF;\n}\n\n.bareme-info h5 {\n  color: #7F8C8D;\n}\n\n.bareme-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 8px;\n}\n\n.bareme-item {\n  font-size: 12px;\n  color: #7F8C8D;\n  padding: 6px 10px;\n  background-color: white;\n  border-radius: 4px;\n  border-left: 3px solid #BDC3C7;\n}\n\n.bareme-item:nth-child(2) {\n  border-left-color: #3498DB;\n}\n\n.bareme-item:nth-child(3) {\n  border-left-color: #F39C12;\n}\n\n.bareme-item:nth-child(4) {\n  border-left-color: #E67E22;\n}\n\n.bareme-item:nth-child(5) {\n  border-left-color: #E74C3C;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
